class LazyLoadingImages {
	constructor() {
		this.init();
	}

	init() {
		document.addEventListener("DOMContentLoaded", function () {
			window.imagesToLazyload = [...document.querySelectorAll('img[data-lazy-img-src]:not(.loaded)')];
			const config = { attributes: false, childList: true, subtree: true };

			const intersectionObserver = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						const img = entry.target;
						const src = img.getAttribute('data-lazy-img-src');
						const picture = img.closest("picture");

						img.src = src;

						img.onload = () => {
							img.classList.add("loaded");
							observer.unobserve(img);
						};

						if (picture) {
							const template = picture.querySelector("template");
							if (template) {
								const sources = [...new DOMParser().parseFromString(template.innerHTML, "text/html").querySelectorAll("source")];

								sources.reverse().forEach(source => {
									picture.prepend(source);
								});

								template.remove();
							}
						}
					}
				});
			});
			const targetNode = document.querySelector("body");
			const mutationObserver = new MutationObserver((mutationList, observer) => {
				mutationList.forEach(mutation => {
					if (mutation.type === "childList") {
						window.imagesToLazyload = [...document.querySelectorAll("img[data-lazy-img-src]:not(.loaded)")];
					}
				});

				intersectionObserver.disconnect();
				window.imagesToLazyload.forEach(image => {
					intersectionObserver.observe(image);
				});
			});

			mutationObserver.observe(targetNode, config);

			imagesToLazyload.forEach(image => {
				intersectionObserver.observe(image);
			});
		});
	}
}

const lazyLoadingObserver = new LazyLoadingImages();
